// src/features/estoque/hooks/useResumoEstoque.js
import { useState, useEffect } from "react";
import { obterResumoFinanceiroEstoque } from "services/estoqueService";

export const useResumoEstoque = (mes, ano) => {
  const [dadosGrafico, setDadosGrafico] = useState([]);
  const [totais, setTotais] = useState({ entradas: 0, saidas: 0 });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const carregarResumo = async () => {
      setIsLoading(true);
      const resultado = await obterResumoFinanceiroEstoque(mes, ano);
      
      setTotais(resultado);
      
      // Adaptando para o formato esperado pelo Recharts, ex: BarChart ou PieChart
      setDadosGrafico([
        { name: "Entradas", valor: resultado.entradas, fill: "#10b981" }, // Verde (Tailwind green-500)
        { name: "Saídas", valor: resultado.saidas, fill: "#f97316" }      // Laranja (Tailwind orange-500)
      ]);
      
      setIsLoading(false);
    };

    carregarResumo();
  }, [mes, ano]);

  return { dadosGrafico, totais, isLoading };
};
